export class NewsDTO {

    id: string;

    title: string;

    image: string;

    content: string;

}
